import { normalizeHexColor } from './index'

export type FograRgb = {
  r: number
  g: number
  b: number
}

export type FograCmyk = {
  c: number
  m: number
  y: number
  k: number
}

export type FograRgbToCmykSuccess = {
  ok: true
  mode: 'rgb-to-cmyk'
  input: {
    rgb: FograRgb
    hex: string
  }
  result: {
    cmyk: FograCmyk
    outOfGamut: boolean
    suggestedColor: {
      sourceHex: string
      cmyk: FograCmyk
    } | null
  }
}

export type FograCmykToRgbSuccess = {
  ok: true
  mode: 'cmyk-to-rgb'
  input: {
    cmyk: FograCmyk
  }
  result: {
    hex: string
    matchedCmyk: FograCmyk
    cmykDelta: number
  }
}

export type FograApiError = {
  ok: false
  error: string
}

export type FograRgbToCmykResponse = FograRgbToCmykSuccess | FograApiError
export type FograCmykToRgbResponse = FograCmykToRgbSuccess | FograApiError

const API_ENDPOINT = '/api/cmyk-conversion'

const getFograRequest = async <T>(
  params: URLSearchParams,
  signal?: AbortSignal
): Promise<T | null> => {
  try {
    const query = params.toString()
    const url = query ? `${API_ENDPOINT}?${query}` : API_ENDPOINT
    const response = await fetch(url, { method: 'GET', signal })

    if (!response.ok) return null

    const json = await response.json()
    return json as T
  } catch (error) {
    return null
  }
}

export const convertFogra39HexToCmyk = (
  hex: string,
  signal?: AbortSignal
) => {
  const normalizedHex = normalizeHexColor(hex)
  if (!normalizedHex) return Promise.resolve(null)

  const params = new URLSearchParams()
  params.set('mode', 'rgb-to-cmyk')
  params.set('hex', normalizedHex)
  return getFograRequest<FograRgbToCmykResponse>(params, signal)
}

export const convertFogra39CmykToRgb = (
  cmyk: FograCmyk,
  signal?: AbortSignal
) => {
  const params = new URLSearchParams()
  params.set('mode', 'cmyk-to-rgb')
  params.set('c', String(cmyk.c))
  params.set('m', String(cmyk.m))
  params.set('y', String(cmyk.y))
  params.set('k', String(cmyk.k))
  return getFograRequest<FograCmykToRgbResponse>(params, signal)
}
